const BaseView = require('components-framework/view/base.view');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const baggageObserverMixin = require('../../../../../webapp/static-content/_versionedByRelease_/js/modules/mixins/baggages_observer.mixin');
const baggageSegmentFactory = require('components/bags_and_seats/baggage/baggage_segment/js/main');

const getAnyOtherSelectableBaggage = (baggageRows) => {
    return baggageRows.find((baggageRow) => baggageRow.rowDescriptor.get('hasSelectableBaggages'));
};

const getBaggageRowMainTemplateData = (baggageRows, paxRowClasses) => {
    return baggageRows.map((baggageRow, index) => {
        const rowId = baggageRow.rowDescriptor.get('idRow');
        const rowClass = index < (baggageRows.length - 1)
            ? 'od-baggage-passenger-stroke' + (Odigeo.AB.isCssVariationMobile ? ' odf-separator-dotted ' : '')
            : '';

        return {
            rowId,
            rowClass: paxRowClasses + ' ' + rowClass,
        };
    });
};

module.exports = withCachedSelectors(BaseView.extend(baggageObserverMixin.extend( {
    containerClasses: '',
    paxRowClasses: '',
    passengersData: '',

    initialize(options) {
        this.onParent = options.onParent;
        this.ancillaryContainer = options.ancillaryContainer;
        this.baggageSelector = options.baggageSelector;
        this.model.set('passengerId', options.passengerId);
        this.bindEvents();
        this.model.set('autoSelectionAvailable', options.autoSelectionAvailable);
        this.model.set('autoSelectionActive', options.autoSelectionAvailable);
        this.model.set('requestType', options.requestType);
        this.model.set('baggageRows', options.baggageRows);
        Odigeo.requireWidget(`passengers${options.passengerId}`, 'passengers_manager', (passenger) => {
            this.model.set('travellerType', passenger?.model.passengerType || '');
        });

        this.rafPaxDatilsUpdate();
    },
    rafPaxDatilsUpdate() {
        if (typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(() => {
                this.renderHeaderIfNeeded();
                this.rafPaxDatilsUpdate();
            });
        } else {
            this.renderHeaderIfNeeded();
        }
    },
    notifyAutoSelectionChanged(segmentModel, segmentStatus) {
        const currentStatus = this.model.get('autoSelectionActive');
        this.model.set('autoSelectionActive', currentStatus && segmentStatus);
    },
    createSegments() {
        const baggageRows = this.model.get('baggageRows');
        const requestType = this.model.get('requestType');
        const autoSelectionAvailable = this.model.get('autoSelectionAvailable');
        const passengerId = this.model.get('passengerId');
        const doesAnySegmentHaveASelectableBaggage = !Odigeo._.isEmpty(getAnyOtherSelectableBaggage(baggageRows));
        this.segments = baggageRows.reduce((acc, baggageRow) => {
            return acc.concat(baggageSegmentFactory.create({
                id: `baggage-segment-${passengerId}-${baggageRow.rowDescriptor.get('idRow')}`,
                idPassenger: passengerId,
                ancillaryContainer: this.ancillaryContainer,
                baggageSelector: this.baggageSelector,
                applyAutoSelection: this.applyAutoSelection.bind(this),
                notifyAutoSelectionChanged: this.notifyAutoSelectionChanged.bind(this),
                isAutoSelectionStillValid: this.isAutoSelectionStillValid.bind(this),
                baggageRow,
                requestType,
                autoSelectionAvailable,
                doesAnySegmentHaveASelectableBaggage,
            }));
        }, []);
    },
    bindEvents: function() {
        this.listenTo(this.model, 'change:baggageRows', this.render);
        this.listenTo(this.model, 'change:baggageRows', this.createSegments);
    },
    render() {
        const data = this.model.toJSON();
        this.$el.html(this.templates.main({
            passengerId: this.model.get('passengerId'),
            baggageRows: getBaggageRowMainTemplateData(data.baggageRows, this.paxRowClasses),
            containerClasses: this.containerClasses,
            headerWrapper: this.templates.headerWrapper(),
        }));
        this.renderHeaderIfNeeded();
    },
    renderHeaderIfNeeded() {
        const sessionPassengersData = Odigeo.Session.get('passengersData');
        if (this.passengersData !== sessionPassengersData) {
            this.passengersData = sessionPassengersData;
            const passengersData = Odigeo.Utils.parseJson(this.passengersData);
            const passengerId = this.model.get('passengerId');
            const defaultTravellerName = `${this.keys.defaultPassengerName} ${passengerId + 1}`;
            if (Odigeo._.isNull(passengersData) || Odigeo._.isUndefined(passengersData)) {
                this.model.set('travellerName', defaultTravellerName);
            } else {
                this.model.setTravellerInfo(passengersData, passengerId, defaultTravellerName);
            }
            this.$el.find('.baggage_passenger_header').html(this.templates.headerContent({
                travellerName: this.model.get('travellerName'),
                travellerType: this.keys[this.model.get('travellerType')],
            }));
        }
    },
    getSecondSegment() {
        return this.segments[1];
    },
    isAutoSelectionStillValid(secondSegmentOption) {
        const autoSelectionActive = this.model.get('autoSelectionActive');
        const passengerId = secondSegmentOption.get('idPassenger');
        const otherLegId = this.getBaggagesRowIdsArray()[0];
        const firstSegmentOption = this.getSameOptionForOtherSegment(passengerId,
            otherLegId, secondSegmentOption.pick('selected'));
        let samePieces = false;
        let sameKilos = false;

        if (firstSegmentOption) {
            const firstSegmentOptionProperties = firstSegmentOption.pick('pieces', 'kilos');
            const secondSegmentOptionProperties = secondSegmentOption.pick('pieces', 'kilos');
            samePieces = firstSegmentOptionProperties.pieces === secondSegmentOptionProperties.pieces;
            sameKilos = firstSegmentOptionProperties.kilos === secondSegmentOptionProperties.kilos;
        }

        return autoSelectionActive && samePieces && sameKilos;
    },
    applyAutoSelection(data) {
        const secondSegment = this.getSecondSegment();
        const isFirstRow = data.get('idRow') === this.getBaggagesRowIdsArray()[0];
        const autoSelectionActive = this.model.get('autoSelectionActive');
        if (autoSelectionActive && isFirstRow) {
            const passengerId = data.get('idPassenger');
            const secondSegmentOption = this.getOtherSegmentEquivalentOption(data, passengerId, 1);
            secondSegment.execute('autoSelect', secondSegmentOption);
        }
    },
    getOtherSegmentEquivalentOption(option, passengerId, legID) {
        const otherLegId = this.getBaggagesRowIdsArray()[legID];
        return this.getSameOptionForOtherSegment(passengerId, otherLegId, option.pick('pieces', 'kilos'))
        || this.getSameOptionForOtherSegment(passengerId, otherLegId, option.pick('pieces'));
    },
    getSameOptionForOtherSegment: function(passengerId, otherLegId, additionalProperties = {}) {
        return this.getFirstBaggageOption(Odigeo._.extend({
            idPassenger: passengerId,
            idRow: otherLegId,
        }, additionalProperties));
    },
})));
